import { render, staticRenderFns } from "./relevance.code.vue?vue&type=template&id=6ecec4f0&scoped=true"
import script from "./relevance.code.vue?vue&type=script&lang=js"
export * from "./relevance.code.vue?vue&type=script&lang=js"
import style0 from "./relevance.code.vue?vue&type=style&index=0&id=6ecec4f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecec4f0",
  null
  
)

export default component.exports